
























































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyError} from "@/utils/notify-helper";
import {InputWings} from "wings-ui-components";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {PoolNumberItem} from "@/store/settings/pools/types";
import {removeItem} from "@/utils/data-helper";
import { Route } from 'vue-router';

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components:{InputWings}})
export default class PoolNumber extends Vue {
  @Action('addPoolNumbers') actionAdd: any;
  @Action('updatePoolNumber') actionUpdate: any;
  @Action('deletePoolNumbers') actionDelete: any;
  @Action('actionLog') actionLog: any;
  @Ref('validator') validator:any;

  defaultItem(): PoolNumberItem {
    return { id: undefined, msisdn: '' };
  }

  private item: PoolNumberItem = this.defaultItem();
  private itemSaved: PoolNumberItem = this.defaultItem();
  private logObject: ActionLog = {};
  private rows: PoolNumberItem[] = [{ msisdn: '' }];
  private selectedRows: PoolNumberItem[] = [];

  async created() {
    if (this.$route.params.numberId) {
      try {
        this.item.id = Number(this.$route.params.numberId);
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "PoolNumber",
        }
        await this.actionLog(this.logObject);
        this.itemSaved = cloneDeep(this.item);
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: 'failed'});
      }
    }
  }

  onSelect(items: PoolNumberItem[]) {
    this.selectedRows = items;
  }

  async addEmptyItem(): Promise<void> {
    let valid:boolean = await this.validator.validate();
    if (valid) {
      if (!this.rows) this.rows = [];
      this.rows.push({ msisdn: '' });
    }
  }

  deleteSelectedItem(): void {
    if (!this.rows || !this.selectedRows) return;
    this.selectedRows.forEach((item: PoolNumberItem) => removeItem(this.rows, item));
    if (this.rows.length === 0) {
      this.addEmptyItem();
    }
  }

  back():void{
    this.$router.push(`/settings/pools/${this.$route.params.id}/numbers`);
  }

  async onSaveItem(): Promise<void> {
    const isValid: boolean = await this.validator.validate();
    if (!isValid) {
      setTimeout(() => notifyError(null, this.validator.errors), 100);
      return;
    }
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Creation",
        action_status: "success",
        object_type: "PoolNumber",
        addititional_info: getTranslatedParams({ msisdn: this.rows })
      };
      const payloadRows = (this.rows || []).map((r: PoolNumberItem) => (r?.msisdn || '').trim()).filter(Boolean);
      await this.actionLog(this.logObject);
      await this.actionAdd({ id: Number(this.$route.params.id), originators: payloadRows });
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      await this.actionLog({ ...this.logObject, action_status: "failed" });
      notifyError(error);
    }
  }

  beforeRouteLeave(to:Route, from:Route, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
